export class TextareaCounter {
  private readonly container: HTMLElement | null
  private readonly valueElement: HTMLElement | null
  private readonly maxElement: HTMLElement | null

  constructor(private readonly element: HTMLTextAreaElement) {
    this.container = element.closest('.field__wrapper')
    this.valueElement = this.container?.querySelector(
      '[data-textarea-counter-value]'
    ) as HTMLElement | null
    this.maxElement = this.container?.querySelector(
      '[data-textarea-counter-max]'
    ) as HTMLElement | null

    this.init()
  }

  private init(): void {
    if (!this.valueElement) return

    this.updateMax()
    this.updateValue()

    this.element.addEventListener('input', () => this.updateValue())

    const form = this.element.closest('form')
    form?.addEventListener('reset', () => {
      setTimeout(() => this.updateValue())
    })
  }

  private updateValue(): void {
    if (!this.valueElement) return

    this.valueElement.textContent = String(this.element.value.length)
  }

  private updateMax(): void {
    if (!this.maxElement) return

    const maxLength = Number(this.element.getAttribute('maxlength'))
    if (Number.isFinite(maxLength) && maxLength > 0) {
      this.maxElement.textContent = String(maxLength)
    }
  }
}
